import { handleActions } from 'redux-actions';
import mergeOptions from 'merge-options';

const initialState = {
  abandonEmailConfirmed: false,
  abandonEmailSent: false,
  acceptedAbandonBasketTerms: false,
  acceptedTermsAndConditions: false,
  bookingOverviewExpanded: false,
  dibsFormArgs: [],
  guestsWidgetVisible: false,
  isNarrow: false,
  loading: false,
  needsUpdateFromBackend: false,
  needsValidateVoucher: false,
  originalAgencyNumber: false,
  // These fields store values from Drupal's values of agency.creditAgency, because TravelAgencySelect section
  // can actually updates both of them.
  originalCreditAgency: false,
  pagerIndex: 1,
  selectedFinalCleaning: null,
  showAbandonBasketPopup: false,
  submitLoading: false,
  termsAndConditionsLink: './assets/demo.pdf',
  totalSteps: 0,
  voucherEnabledForMarketBrand: true,
};

const appearanceAppState = handleActions(
  {
    INIT_FROM_DRUPAL: state => {
      const novasolData = window.novasolData || undefined;

      if (novasolData instanceof Object) {
        const newState = mergeOptions({},
          state);
        newState.imageUrl = novasolData.imageUrl;
        newState.termsAndConditionsLink = novasolData.termsAndConditionsLink;

        if (novasolData.abandonBasketConfirmed) {
          newState.abandonEmailConfirmed = novasolData.abandonBasketConfirmed;
          newState.showAbandonBasketPopup = true;
        }

        newState.addressFormat = JSON.parse(novasolData.addressFormat);
        newState.voucherEnabledForMarketBrand =
          window.voucherEnabledForMarketBrand;
        return newState;
      }
      return state;
    },
    RESET_STATE: (state, action) =>
      mergeOptions({},
        state,
        action.payload.appearanceAppState,
        {
          loading: false,
          needsUpdateFromBackend: false,
          submitLoading: false,
          needsValidateVoucher: false,
          showAbandonBasketPopup: true,
          abandonEmailSent: false,
        }),

    UPDATE_NARROW_STATE: (state, action) => ({
      ...state,
      isNarrow: action.payload,
    }),

    NEXT_STEP: state => ({ ...state, pagerIndex: state.pagerIndex + 1 }),

    PREV_STEP: state => ({ ...state, pagerIndex: state.pagerIndex - 1 }),

    UPDATE_TOTAL_STEPS: (state, action) => ({
      ...state,
      totalSteps: action.payload,
    }),

    UPDATE_EXTRA_SERVICES: (state, action) => {
      const newState = mergeOptions({},
        state);

      if (action.payload.serviceId === '8019') {
        newState.selectedFinalCleaning = action.payload.value;
      }

      newState.needsUpdateFromBackend = true;
      return newState;
    },

    UPDATE_GUEST_OPTIONS: state => ({ ...state, needsUpdateFromBackend: true }),

    UPDATE_TICKETS: state => ({ ...state, needsUpdateFromBackend: true }),

    SELECT_PAYMENT_OPTION: state => ({
      ...state,
      needsUpdateFromBackend: true,
    }),

    UPDATE_FROM_BACKEND: state => ({
      ...state,
      loading: false,
      needsUpdateFromBackend: false,
    }),

    RECEIVE_FROM_BACKEND: state => ({
      ...state,
      loading: true,
      needsUpdateFromBackend: false,
      needsValidateVoucher: false,
    }),

    START_SUBMIT_LOADING: (state, action) => ({
      ...state,
      submitLoading: action.payload,
    }),

    STOP_LOADING: state => ({
      ...state,
      loading: false,
      needsValidateVoucher: false,
    }),

    ACCEPT_TERMS: state => ({
      ...state,
      acceptedTermsAndConditions: !state.acceptedTermsAndConditions,
    }),

    UPDATE_AGENCY_NUMBER: state => ({ ...state, needsUpdateFromBackend: true }),

    SET_ORIGINAL_AGENCY_INFO: (state, action) => ({
      ...state,
      originalCreditAgency: action.payload.creditAgency,
      originalAgencyNumber: !!action.payload.agencyNumber,
    }),

    UPDATE_BOOKING_OVERVIEW: (state, action) => ({
      ...state,
      bookingOverviewExpanded: action.payload,
    }),

    RECEIVED_DIBS_FORM: (state, action) => ({
      ...state,
      dibsFormArgs: action.payload,
    }),

    TOGGLE_ABANDON_BASKET_TERMS: state => ({
      ...state,
      acceptedAbandonBasketTerms: !state.acceptedAbandonBasketTerms,
    }),

    UPDATE_VOUCHER_BACKEND: state => ({ ...state, needsValidateVoucher: true }),

    CUSTOMER_LEAVE: state => ({ ...state, showAbandonBasketPopup: true }),

    UPDATE_ABANDON_BASKET_STATE: (state, action) => ({
      ...state,
      abandonEmailSent: action.payload,
    }),
    HIDE_ABANDON_BASKET: state => ({ ...state, showAbandonBasketPopup: false }),
  },
  initialState
);

export default appearanceAppState;
